﻿import { throttle } from '../functions';

document.addEventListener('DOMContentLoaded', () => {
    const $body = document.body;

    let prevScrollpos = window.scrollY;
    let newScrollpos = prevScrollpos;
    window.addEventListener('scroll', throttle(() => {
        newScrollpos = window.scrollY;
        const ymax = document.documentElement.scrollHeight - window.innerHeight;
        if (newScrollpos <= 0) {
            $body.classList.add('is-top');
        }
        else {
            $body.classList.remove('is-top');
        }
        if (prevScrollpos - newScrollpos < 0) {
            $body.classList.add('scrollDown');
            $body.classList.remove('scrollUp');
        } else if (prevScrollpos - newScrollpos > 0) {
            $body.classList.add('scrollUp');
            $body.classList.remove('scrollDown');
        }
        prevScrollpos = Math.min(Math.max(newScrollpos, 0), ymax);
    }, 10));
});